<template>
    <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
            <div class="modal-dialog">
                <div class="modal-content modal-width">
                    <div class="modal-body" style="background-color:white;">
                        <div class="close_btn" v-on:click="CloseModal()"></div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <p>{{message}}</p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 right">
                                <button class="order-form-button" v-on:click="Agree()">Yes</button>
                                <button class="order-form-button" v-on:click="CloseModal()">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['message'],
    data() {
        return {

        }
    },
    methods: {
        CloseModal(){
            this.$emit("close");
        },
        Agree(){
            this.$emit("onAgree");
        }
    }
}
</script>



// WEBPACK FOOTER //
// PromptComponent.vue?687bd5f6